module.exports = __webpack_public_path__ + "static/media/drawkit-notebook-man-monochrome.b6c3c119.svg";